/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row1_KbInputs */

const en_mk_cmp_row1_kb = /** @type {(inputs: Mk_Cmp_Row1_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our servers — nothing to install`)
};

const id_mk_cmp_row1_kb = /** @type {(inputs: Mk_Cmp_Row1_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server kami — tanpa instalasi`)
};

/**
* | output |
* | --- |
* | "Our servers — nothing to install" |
*
* @param {Mk_Cmp_Row1_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row1_kb = /** @type {((inputs?: Mk_Cmp_Row1_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row1_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row1_kb(inputs)
	return en_mk_cmp_row1_kb(inputs)
});